import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Progress } from 'reactstrap';
import classNames from 'classnames';
import { mapToCssModules } from 'reactstrap/lib/utils';
import { Tooltip } from 'antd';

const propTypes = {
    header: PropTypes.string,
    icon: PropTypes.string,
    color: PropTypes.string,
    value: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    cssModule: PropTypes.object,
    invert: PropTypes.bool,
    showInfoIcon: PropTypes.bool,
    toolTip: PropTypes.string,
};

const defaultProps = {
    header: '87.500',
    icon: 'icon-people',
    color: 'info',
    value: '0',
    children: 'Visitors',
    invert: false,
    showInfoIcon: false,
    toolTip: '',
};

class Widget04 extends Component {
    render() {
        const { className, cssModule, header, icon, color, value, children, invert, showInfoIcon, toolTip, ...attributes } = this.props;

        // demo purposes only
        const progress = { style: '', color: color, value: value };
        const card = { style: '', bgColor: '', icon: icon };

        if (invert) {
            progress.style = 'progress-white';
            progress.color = '';       
            card.style = 'text-white';
            card.bgColor = 'bg-' + color;
        }

        const classes = mapToCssModules(classNames(className, card.style, card.bgColor), cssModule);
        progress.style = classNames('progress-xs mt-3 mb-0', progress.style);

        const ToolTipIcon = (
            <Tooltip title={toolTip}>
                <icon className="icon-inform text-icon cursor-pointer-d  dash-icon-inform " />
            </Tooltip>
        )

        return (
            <Card className={classes} {...attributes} >
                <CardBody>
                    <div className="row no-gutters" >
                    <div className="width-80  text-uppercase font-weight-bold">{children}</div>
                    <div className="width-20  text-right h5">{showInfoIcon && ToolTipIcon}</div>   
                    </div>             
                    <div className="row no-gutters mt-3 d-f-c"  >
                       <div className="width-20 float-left text-left h1"><span className={card.icon}></span></div>
                       <div  className="width-80 h1">{header}</div>
                    </div>  
                    {/* <Progress className={progress.style} color={progress.color} value={progress.value} /> */}
                </CardBody>
            </Card>
        );
    }
}

Widget04.propTypes = propTypes;
Widget04.defaultProps = defaultProps;

export default Widget04;